import { useAuth } from '@/contexts/AuthContext';
import { X } from 'lucide-react';
import React from 'react';
import { createPortal } from 'react-dom';
import PlanSelector, { type UserPlanInfo } from './PlanSelector';
import styles from './PricingModal.module.scss';

interface PricingModalProps {
    isOpen: boolean;
    onClose: () => void;
    fisrt?: boolean;
}

export const PricingModal: React.FC<PricingModalProps> = ({
    isOpen, onClose, fisrt
}) => {
    const {
        userBilling: { userPlan },
        currentWorkspace
    } = useAuth();

    if (!isOpen) return null;

    const userPlanInfo: UserPlanInfo = {
        planCode: userPlan?.planCode,
        billingCycle: userPlan?.billingCycle as 'monthly' | 'yearly' | undefined,
        status: userPlan?.status,
        currentPeriodEnd: userPlan?.currentPeriodEnd,
        trialEndAt: userPlan?.trialEndAt
    };

    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.centeredWrapper}>
                <div
                    className={styles.modalContainer}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                    >
                        <X size={24} />
                    </button>

                    <div className={styles.header}>
                        <h2 className={styles.title}>Pricing for Bustly</h2>
                    </div>

                    <div className={styles.cardsContainer}>
                        <PlanSelector
                            mode="upgrade"
                            userPlan={userPlanInfo}
                            workspaceId={currentWorkspace?.id || ''}
                        />
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export * from './Welcome';
